import { useEffect, useRef } from "react"

import { useTranslation } from "react-i18next"

import styles from "./evidencePane.module.less"

// Renders one decoded page onto a canvas (no <img src>, no extractable URL).
const PageCanvas = ({ bitmap, index }) => {
  const { t } = useTranslation()
  const ref = useRef(null)

  useEffect(() => {
    const c = ref.current
    // A bitmap closed mid-swap (rapid version/draft changes) is detached: width/height
    // read 0 and drawImage throws "image source is detached", which would blank the
    // page. Skip it; the next render draws the live bitmap. Guarding both avoids the
    // empty-PDF flash and the console error.
    if (!c || !bitmap || !bitmap.width || !bitmap.height) return
    try {
      c.width = bitmap.width
      c.height = bitmap.height
      c.getContext("2d").drawImage(bitmap, 0, 0)
    } catch (_e) {
      /* detached during a concurrent swap; a later render redraws the current page */
    }
  }, [bitmap])

  return (
    <canvas
      ref={ref}
      className={styles.pageImg}
      // The scroll tracking in EvidencePane locates pages by this attribute rather than
      // by the class, so styling can be renamed without breaking page navigation.
      data-page={index}
      role="img"
      aria-label={t("Evidence page _n_", { n: index + 1 })}
      onContextMenu={(e) => e.preventDefault()}
    />
  )
}

export default PageCanvas
